import { createChatKeyInput, updateChatKeyInput } from './webchat/embed.js';
/**
 * Schlüssel für das Anfrageformular der eigenen Webseite (Einrichtung → APIs und Webhooks → Anfragen (Webseite), KON-237). Der Mandant legt sie selbst an, statt sie bei Wirkia anzufragen. Ein Schlüssel hat den
 * Bereich `inquiries:create`: Er kann Anfragen (und deren Anhänge) entgegengeben und sonst nichts. Er steht in der `.env` der Webseite, auf Wunsch auch im Browser, und gilt zusätzlich nur auf den
 * eingetragenen Webseiten. Anders als sonst bei Schlüsseln lässt er sich später wieder anzeigen (verschlüsselt gespeichert), aus- und einblendbar in der Oberfläche.
 */
export const WEBSITE_KEY_SCOPE = 'inquiries:create';
/** Schlüssel für die Newsletter-Anmeldung auf der eigenen Webseite (Modul Marketing) */
export const NEWSLETTER_KEY_SCOPE = 'marketing:subscribe';
export const WEBSITE_KEYS_MAX = 5;
export const createWebsiteKeyInput = createChatKeyInput;
export const updateWebsiteKeyInput = updateChatKeyInput;
/** Name der Variable in der `.env`: Anfrage- und Newsletter-Schlüssel sind verschiedene Schlüssel und brauchen verschiedene Namen, sonst überschreibt einer den anderen */
export const websiteEnvName = (kind) => (kind === 'newsletter' ? 'WIRKIA_NEWSLETTER_API_KEY' : 'WIRKIA_INQUIRY_API_KEY');
/** Zeilen für die `.env` der Webseite */
export function websiteEnv(apiUrl, key, kind = 'inquiries') {
    return `WIRKIA_API_URL=${apiUrl}\n${websiteEnvName(kind)}=${key}`;
}
/** Beispielaufruf, mit dem die Webseite eine Anfrage an Wirkia sendet (serverseitig, der Schlüssel bleibt in der `.env`) */
export function websiteCurl(apiUrl, key, type) {
    const fields = Object.fromEntries((type?.fields ?? []).slice(0, 4).map((f) => [f.key, f.type === 'number' ? 2 : f.type === 'boolean' ? true : f.label]));
    const body = {
        type: type?.key ?? 'beratung',
        source: 'website',
        contact: { name: 'Max Mustermann', email: 'max@beispiel.de', phone: '0151 1234567' },
        message: 'Bitte um ein Angebot.',
        fields,
        consentAt: '2026-10-22T09:00:00+02:00',
    };
    return `curl -X POST ${apiUrl}/inquiries \\\n  -H "Authorization: Bearer ${key}" \\\n  -H "Content-Type: application/json" \\\n  -d '${JSON.stringify(body, null, 2)}'`;
}
/** Beispielaufruf für die Newsletter-Anmeldung: Die Webseite sendet Name, E-Mail und die Einwilligung des Besuchers an Wirkia, der Besucher bekommt danach eine Bestätigungsmail */
export function newsletterCurl(apiUrl, key) {
    const body = { name: 'Max Mustermann', email: 'max@beispiel.de', consent: true, consentText: 'Ich möchte den Newsletter erhalten.' };
    return `curl -X POST ${apiUrl}/marketing/subscribe \
  -H "Authorization: Bearer ${key}" \
  -H "Content-Type: application/json" \
  -d '${JSON.stringify(body, null, 2)}'`;
}
//# sourceMappingURL=website-keys.js.map